<template lang="pug">
div.upper-subpanel--inside
  div.col-6
    DrugInfo
  div.col-6
    ConfirmFlow(
      v-if="currentProgress ==='confirm'"
      :confirmProgress="confirmProgress"
      :actionProgress="actionProgress"
      :barcodeData="barcodeData"
      :startType="startType"
      v-on:confirmationFinish="getConfirmData"
    )
    ReturnEmptyBottle(
      v-if="currentProgress === 'returnEmpty'"
      :controlMed="currentDrugInDevice.medication"
      v-on:returnEmptyBottleFinish="getConfirmData"
    )
    Loader(
      v-if="currentProgress === 'finish'"
    )
</template>

<script>
import MultiFlowBase from '../ComponentBase/MultiFlowBase';
import ConfirmFlow from './ConfirmFlow';
import ReturnEmptyBottle from './ReturnEmptyBottle';
import DrugInfo from '../flowComp/DrugInfo';
import Loader from '../common/Loader';


export default {
  name: 'multiFlow',
  extends: MultiFlowBase,
  components: {
    ConfirmFlow,
    DrugInfo,
    ReturnEmptyBottle,
  },
  props: ['barcodeData', 'startType'],
  data() {
    return {
    };
  },
  methods: {
    getConfirmData() {
      this.resetProgress();
      console.log('get confirm data');
      if (this.nextEvent === null || this.nextDrugInDevice === null) {
        this.$emit('setAllConfirmData');
      } else {
        this.$store.dispatch('toNextEvent');
        console.log('next event');
        this.eventSwitch();
      }
    },
    eventSwitch() {
      // dirty hack for waiting
      if (this.$store.state.generalSetting.mode === 'aeth') {
        if (this.currentDrugInDevice.medication.restrained_class > 0) {
          this.nextProgress();
        }
      }
    },
  },
  created() {
    if (this.startType === 'event') {
      console.log(this.selectedEventId);
      this.$store.dispatch('fromFirstEvent');
    }
    if (this.startType === 'drugStorage') {
      this.$store.dispatch('fromFirstDrugInDevice');
    }
    this.eventSwitch();
  },
  computed: {
    selectedEventId() {
      return this.$store.state.event.selectedEventId;
    },
  },
};
</script>




// WEBPACK FOOTER //
// MultiFlow.vue?6a5bab9b